import Plyr from "plyr";
import "plyr/dist/plyr.css";

window.Plyr = Plyr;

function playPauseVideo() {
    let videos = document.querySelectorAll("video.autoplay");
    videos.forEach((video) => {
        // We can only control playback without interaction if video is muted
        video.muted = true;

        // Play is a promise so we need to check we have it
        let playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.then((_) => {
                let observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.intersectionRatio !== 1 && !video.paused) {
                                video.pause();
                            } else if (video.paused) {
                                video.play();
                            }
                        });
                    },
                    { threshold: 0.2 }
                );
                observer.observe(video);
            });
        }
    });
}

// And you would kick this off where appropriate with:
playPauseVideo();
